import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch, getCurrentInstance } from 'vue';
import QuilityAPI from '../../../store/API/QuilityAPI';
import FmlQuestionSet from '../../../FML/views/FmlQuestionSet.vue';
import QButton from '../../shared/components/QButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FormWithStepsRenderer',
  props: {
    slug: null,
    hideSubmitButton: { type: Boolean },
    color: null,
    doNotSubmit: { type: Boolean },
    redirectOnSave: { type: Boolean }
  },
  emits: ["saved"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'saved'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  slug?: string,
  hideSubmitButton?: boolean,
  color?: string,
  doNotSubmit?: boolean,
  redirectOnSave?: boolean,
}





const form = ref<any>(null)
const errorMessage = ref('')
const currentStepIndex = ref(0)
const currentStep = computed(() => form.value?.FormQuestionSets[currentStepIndex.value])

const showBlock = (getCurrentInstance()?.proxy.$root as any).showBlock

const load = () => {
  QuilityAPI.getFormWithSlug(props.slug, 'new', ['SingleEntryResponse'])
    .then((data: any) => {
		data.FormQuestionSets = data.FormQuestionSets
			.map((questionSet: any) => {
				const FormQuestions = questionSet.FormQuestions?.filter((question: any) => showBlock(question.FormQuestionConfig))
				return { ...questionSet, FormQuestions }
			})
			.filter((questionSet: any) => {
				if (!showBlock(questionSet.FormQuestionSetConfig)) { return false }
				if (!questionSet.FormQuestions?.length) { return false }
				return true
			})
		form.value = data
		errorMessage.value = ''
    })
	.catch((e: Error) => {
		form.value = null
		errorMessage.value = e.message
	})
}

const back = () => {
  if (currentStepIndex.value === 0) {
    return
  }
  currentStepIndex.value--
}

const onSave = () => {
  if (currentStepIndex.value === form.value.FormQuestionSets.length - 1) {
    currentStepIndex.value = 0
    emit('saved')
    return
  }

  currentStepIndex.value++
}

watch(() => props.slug, () => {
  form.value = null
  currentStepIndex.value = 0
  if (!props.slug) {
    return
  }

  load()
}, { immediate: true })

return { __sfc: true,props, emit, form, errorMessage, currentStepIndex, currentStep, showBlock, load, back, onSave, FmlQuestionSet, QButton }
}

})